// @flow
import * as React from "react";
import {injectIntl} from "react-intl";
import {reisy, use} from "reisy";

import type {Publishable} from "../api/types.js";
import TimeAgo from "../components/time.js";
import messages from "../components/globallocales.js";
import Heading from '../components/heading';

const styles = reisy`
@namespace SectionHeader;

Container {
	flex-basis: 100%;
	position: relative;
	margin: 0 auto;
	padding: 4em 3em 0;
	text-align: center;
	box-sizing: border-box;

	$Media.smallest {
		padding-left: .5rem;
		padding-right: .5rem;
	}
}

Title {
	@extends Typography.SectionTitle;
	margin: 0 0 .15em 0;

	$Section.hasBackground & {
		color: $Colors.TextLight;
	}
}

Subtitle {
	@extends Typography.SectionSubtitle;
	margin: .25em 0;

	$Section.hasBackground & {
		color: $Colors.TextLight;
	}
}

Description {
	@extends Typography.SectionDesc;
	margin: 1em 0;
	font-family: $Fonts.text;
}

Info {
	font-family: $Fonts.aside;
	font-size: 0.75em;
	display: block;
	margin: 0 auto;
	padding: 0;
	color: $Colors.TextSubtle;
	
	li {
		display: inline-block;
	}
	li + li::before {
		display: inline-block;
		content: "·";
		padding: 0 0.1em;
	}
}
hasBackground {
	color: #E0E0E0;
}
`;

type Props = {
	content: Publishable;
	intl: any; // TODO: use real Intl Type here.
};

const itemCounts = content => ({
	both: false,
	total: content.itemCount,
	collections: 0,
	stories: content.itemCount,
});

const settings = reisy.namespace("Settings");

const SectionHeader = ({content, headingLvl, intl: {formatMessage}}: Props) => (
	<header {...use(styles.Container)}>
		<Heading lvl={headingLvl} {...use(styles.Title)}>{content.title}</Heading>
		{content.subTitle && <p {...use(styles.Subtitle)}>{content.subTitle}</p>}
		{content.description && <div {...use(styles.Description)}>{content.description}</div>}
		{(settings.ShowItemCounts || settings.ShowTime) &&
			<ul {...use(styles.Info, content.background ? styles.hasBackground : null)}>
				{settings.ShowItemCounts && <li>{formatMessage(messages.itemCounts, itemCounts(content))}</li>}
				{settings.ShowTime && <li><TimeAgo time={content.publishDate} /></li>}
			</ul>
		}
	</header>
);

export default injectIntl(SectionHeader);



// WEBPACK FOOTER //
// ./lib/publishables/sectionheader.js